import { useTranslation } from "react-i18next";
import LegalLayout from "@/components/LegalLayout";

const sections = [
  {
    id: "what",
    title: "What cookies are",
    body: [
      "Cookies are small text files stored on your device by your browser. Similar technologies (local storage, pixel tags, SDKs) work the same way.",
    ],
  },
  {
    id: "types",
    title: "Cookies we use",
    body: [
      "Strictly necessary — sign-in, security, load balancing. Always on; you can't opt out without breaking the Service.",
      "Functional — remembers preferences like language and currency.",
      "Analytics — Plausible / self-hosted PostHog, aggregated only. No cross-site tracking.",
      "Marketing — none currently. Should this change we'll ask consent up-front.",
    ],
  },
  {
    id: "manage",
    title: "How to manage",
    body: [
      "You can accept, reject, or fine-tune categories via our cookie banner. You can also clear cookies via your browser settings at any time.",
      "For 'Do Not Track' signals, we treat them as an opt-out of analytics cookies.",
    ],
  },
  {
    id: "third",
    title: "Third parties",
    body: [
      "We do not use ad-tech third parties. Analytics processors are contractually bound to process data only on our instructions.",
    ],
  },
  {
    id: "changes",
    title: "Changes",
    body: [
      "We'll update this policy if we add or remove cookie categories. Material changes will be surfaced via the cookie banner.",
    ],
  },
];

export default function Cookies() {
  const { t } = useTranslation();
  return (
    <LegalLayout
      eyebrow={t("pageHero.cookies.eyebrow")}
      title={t("pageHero.cookies.title")}
      updated="December 2025"
      sections={sections}
      testId="cookies-page"
    />
  );
}
